export function getPickerButtonText(
  count: number,
  itemType: string,
  defaultText?: string,
  format?: 'default' | 'simple'
): string {
  if (count === 0) {
    return defaultText || `Выбор ${itemType}`;
  }

  if (format === 'simple') {
    return `${itemType}: ${count}`;
  }

  return `Выбрано ${itemType}: ${count}`;
}

export const PickerTexts = {
  departments: (count: number) =>
    getPickerButtonText(count, 'участков', 'Выбор участков'),
  roles: (count: number) =>
    getPickerButtonText(count, 'ролей', 'Выбор ролей'),
  executors: (count: number) =>
    getPickerButtonText(count, 'исполнителей', 'Выбор исполнителей'),
  objectTypes: (count: number) =>
    getPickerButtonText(count, 'типов объектов', 'Выбор типов объектов'),
  taskTypes: (count: number) =>
    getPickerButtonText(count, 'типов нарядов', 'Выбор типов нарядов'),
  characteristics: (count: number) =>
    getPickerButtonText(count, 'характеристик', 'Выбор характеристик'),
  plannedWorks: (count: number) =>
    getPickerButtonText(count, 'плановых работ', 'Выбор плановых работ'),
  closingCodes: (count: number) =>
    getPickerButtonText(
      count,
      'шифров закрытия нарядов',
      'Выбор шифров закрытия нарядов'
    ),
  attainments: (count: number) =>
    getPickerButtonText(
      count,
      'навыков и допусков',
      'Выбор навыков и допусков'
    ),
  employees: (count: number) =>
    getPickerButtonText(count, 'сотрудников', 'Выбор сотрудников'),
  works: (count: number) =>
    getPickerButtonText(count, 'работ', 'Выбор работ')
};

